module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("4nmVh"))).then(() => parcelRequire('dSrDj'));